import {
	HomePageScreen,
	KickingballScreen,
	WelcomeScreen,
	EventsScreen,
	PlayersScreen,
	LeagueScreen,
	TorneoOtonoScreen,
	MadMixScreen,
	LeagueThirdScreen,
	LeagueFourthScreen,
	MadMixRostersScreen,
	MadMixConditionsScreen,
	// KickMixScreen,
	TermsScreen,
} from "@/screens";
// import PlayerTendencyChart from "@/screens/public/Print/PlayerTendencyChart.vue";

export default [
	{
		name: "Home",
		path: "/",
		component: HomePageScreen,
	},
	{
		name: "Kickingball",
		path: "/que-es-el-kickingball",
		component: KickingballScreen,
	},
	{
		name: "Terms",
		path: "/guia",
		component: TermsScreen,
	},
	{
		name: "Welcome",
		path: "/club",
		component: WelcomeScreen,
	},
	{
		name: "Events",
		path: "/events",
		component: EventsScreen,
	},
	{
		name: "Players",
		path: "/equipo",
		component: PlayersScreen,
	},
	{
		name: "League",
		path: "/liga-2",
		component: LeagueScreen,
	},
	{
		name: "League",
		path: "/liga-3",
		component: LeagueThirdScreen,
	},
	{
		name: "League",
		path: "/liga-4",
		component: LeagueFourthScreen,
	},
	{
		name: "MadMix",
		path: "/madmix",
		component: MadMixScreen,
	},
	// {
	// 	name: "KickMix",
	// 	path: "/torneo-kickmix",
	// 	component: KickMixScreen,
	// },
	{
		name: "TorneoOtono",
		path: "/torneo-otono",
		component: TorneoOtonoScreen,
	},
	{
		name: "MadMixRoster",
		path: "/madmix/:edition/roster/:teamId",
		component: MadMixRostersScreen,
	},
	{
		name: "MadMixConditionss",
		path: "/madmix-2024",
		component: MadMixConditionsScreen,
	},
];
